import axios from 'axios';
import React from 'react'

export const RequestForServiceContact = () => {
  const [address, setAddress] = React.useState([]);
  const [showPopup, setShowPopup] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const getAddress = async () => {
    // const token =  localStorage.getItem('token');
    const token = "8581ab59d19b8b55ea824a9bd9406ffb27add3e3";
    try {
      const response = await axios.get('https://api.avyayam.in/api/v1/product/services/?page=1&page_size=10', {
        headers: {
          accept: 'application/json',
          Authorization: `Token ${token}`
        }
      });
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      console.log("first", response.data.results);
      setAddress(response.data.results);
    } catch (error) {
      console.error('Error fetching address:', error);
    }
  }

  React.useEffect(() => {
    getAddress();
  }, []);

  const handleView = (item) => {
    setSelectedItem(item);
    setShowPopup(true);
  }

  return (
    <div className="overflow-x-auto relative shadow-md sm:rounded-lg">
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="px-6 py-3">UID</th>
            <th scope="col" className="px-6 py-3">Category Name</th>
            <th scope="col" className="px-6 py-3">Provider Name</th>
            <th scope="col" className="px-6 py-3">Type</th>
            <th scope="col" className="px-6 py-3">Location</th>
            <th scope="col" className="px-6 py-3">Description</th>
            <th scope="col" className="px-6 py-3">Status</th>
            <th scope="col" className="px-6 py-3">Created Date</th>
            <th scope="col" className="px-6 py-3">Action</th>
          </tr>
        </thead>
        <tbody>
          {address.map(item => (
            <tr key={item.uid} className="bg-white border-b dark:bg-gray-900 dark:border-gray-700">
              <td className="px-6 py-2">{item.uid}</td>
              <td className="px-6 py-2">{item.category_name}</td>
              <td className="px-6 py-2">{item.provider_name}</td>
              <td className="px-6 py-2">{item.type}</td>
              <td className="px-6 py-2">{item.location}</td>
              <td className="px-6 py-2">{item.description}</td>
              <td className="px-6 py-2">{item.status}</td>
              <td className="px-6 py-2">{item.created_date}</td>
              <td className="px-6 py-2">
                <button
                  type="button"
                  onClick={() => handleView(item)}
                  className="text-white bg-[#219d8e] hover:bg-bg-[#219d8e] focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-bg-[#219d8e] dark:hover:bg-bg-[#219d8e] focus:outline-none dark:focus:ring-blue-800"
                >
                  View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showPopup && selectedItem && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-300 bg-opacity-50">
          <div className="flex items-center justify-center h-full">
            <div className="bg-white p-10 rounded-lg">
              <h2 className="text-2xl font-bold mb-4">Service Details</h2>
              <p><strong>UID:</strong> {selectedItem.uid}</p>
              <p><strong>Category Name:</strong> {selectedItem.category_name}</p>
              <p><strong>Provider Name:</strong> {selectedItem.provider_name}</p>
              <p><strong>Type:</strong> {selectedItem.type}</p>
              <p><strong>Location:</strong> {selectedItem.location}</p>
              <p><strong>Description:</strong> {selectedItem.description}</p>
              <p><strong>Status:</strong> {selectedItem.status}</p>
              <p><strong>Created Date:</strong> {selectedItem.created_date}</p>
              <button
                type="button"
                onClick={() => setShowPopup(false)}
                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

